import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import LogoDompetKartini from "../assets/images/logo-dompet-kartini-text-1.png";
import ModalBasic from "../components/ModalBasic";
import ModalLoading from "../components/ModalLoading";
import { HEADER, isValidEmail, logger } from "../utils/Utils";
import Footer from "../components/Footer";
import ButtonRequire from "../components/Button/ButtonRequire";

export default function Signin() {
  const [email, setEmail] = useState("");
  const [isSent, setIsSent] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const navigate = useNavigate();
  const [isWebkit, setIsWebkit] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect if the browser is a mobile browser
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileBrowser = /\b(iphone|ipad)\b/i.test(userAgent);
    setIsMobile(isMobileBrowser);
  }, []);

  useEffect(() => {
    // Detect if the browser is WebKit
    const isWebkitBrowser =
      "WebkitAppearance" in document.documentElement.style;
    setIsWebkit(isWebkitBrowser);
  }, []);

  // Function signin
  function Signin(e) {
    e.preventDefault();
    setShowModalLoading(true);
    // Hit api for sent request otp
    fetch(`${process.env.REACT_APP_BASE_URL_API}/v2/account/signin/ppv/index`, {
      method: "POST",
      headers: HEADER,
      body: JSON.stringify({
        param: email,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data.sent) {
          setShowModalLoading(false);
          logger("Success sent otp...");
          setIsSent(true);
          // move to screen confirm otp with timeout
          setTimeout(navigate("/confirm-otp", { state: { email } }), 2000);
        } else {
          setShowModalLoading(false);
          logger("Failed sent otp...");
          setIsSent(false);
        }
      })
      .catch((error) => {
        logger("Failed sent otp...");
        setShowModalLoading(false);
        setIsSent(false);
        console.error("Error:", error);
      });
  }

  return (
    <>
      {localStorage.getItem("dompet_user") ||
      localStorage.getItem("dompet_detail_outlet") ? (
        <Navigate to="/" />
      ) : (
        <>
          <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
          />
          <ModalBasic
            id="message-confirm-modal"
            modalOpen={showModal}
            setModalOpen={setShowModal}
            title="Confirm Message"
            enClose={true}
          >
            <div className="px-5 py-4">
              {isSent ? (
                <p className="text-gray-500">
                  Success sent otp to
                  <span className="text-indigo-500 font-medium">{email}</span>
                </p>
              ) : (
                <p className="text-gray-500">
                  Failed sent otp to
                  <span className="text-indigo-500 font-medium">{email}</span>
                </p>
              )}
            </div>
          </ModalBasic>
          <main className="relative bg-[#FDFDFD]">
            <div
              className="w-full flex justify-center items-center"
              style={{
                height: isMobile
                  ? isWebkit
                    ? "-webkit-fill-available"
                    : "100vh"
                  : "100vh",
              }}
            >
              <img
                className=" object-center w-56"
                src={LogoDompetKartini}
                alt="Kartini"
              />
            </div>
            <div className="absolute bottom-20 w-full px-4 pb-3">
              {/* Form */}
              <form>
                <div className="space-y-4">
                  <div>
                    <input
                      id="email"
                      placeholder="Email"
                      className={`form-input w-full h-12 ${
                        !isSent && "border-red-300"
                      }`}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                    />
                    {!isSent && (
                      <div className="text-xs mt-1 text-white">
                        E-mail not registered!
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-col mt-3 space-y-2">
                  <ButtonRequire
                    title="Sign In"
                    functionOnClick={Signin}
                    isDisabled={!isValidEmail(email)}
                  />
                </div>
              </form>
            </div>
            <div className="absolute bottom-0 w-full px-4 pb-3">
              <Footer
                color="#7D7C7C"
                text={
                  <>
                    By signing in to <strong>DOMPET KARTINI</strong>, you agree
                    to our <strong>Terms</strong> and{" "}
                    <strong>Privacy Policy</strong>.
                  </>
                }
              />
            </div>
          </main>
        </>
      )}
    </>
  );
}
